<script lang="ts" setup>
import LinePlus from '@docue/docue-ui-v2/icons/LinePlus.vue'
import LineMinus from '@docue/docue-ui-v2/icons/LineMinus.vue'

const props = withDefaults(defineProps<{
  disabled?: boolean
  modelValue: number
  min?: number
  max?: number
}>(), {
  min: Number.NEGATIVE_INFINITY,
  max: Number.POSITIVE_INFINITY,
})

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

const modelValue = computed({
  get: () => props.modelValue,
  set: (val) => {
    const newValue = Math.min(Math.max(val, props.min), props.max)

    emit('update:modelValue', Number.isFinite(newValue) ? newValue : props.min)
  },
})

const isIncrementEnabled = computed(() => modelValue.value < props.max)
const isDecrementEnabled = computed(() => modelValue.value > props.min)

const onBlur = (e: FocusEvent) => {
  const target = e.target as HTMLInputElement
  const number = Number(target.value)
  if (Number.isNaN(number) || !number || number !== modelValue.value)
    modelValue.value = 1

  target.value = modelValue.value.toString()
}
</script>

<template>
  <div class="flex gap-1">
    <DTIconButton
      :disabled="!isDecrementEnabled || disabled"
      @click="modelValue--"
    >
      <LineMinus class="size-5" />
    </DTIconButton>
    <input
      v-bind="$attrs"
      v-model="modelValue"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      placeholder="1"
      :disabled="disabled"
      class="
          ml-[0.08rem]
          w-0
          rounded-lg
          border
          border-transparent
          px-2
          focus-visible:!border-gray-800
          focus-visible:outline-none
          "
      :style="{
        minWidth: `calc(${String(modelValue).length}ch + 1.08rem)` /* .08 prevents clipping of 0 */,
      }"
      @blur="onBlur"
    >
    <DTIconButton
      :disabled="!isIncrementEnabled || disabled"
      @click="modelValue++"
    >
      <LinePlus class="size-5" />
    </DTIconButton>
  </div>
</template>
